import Modal, { ModalProps } from '@common/modal';
import Button from '@components/common/button';
import Text from '@components/common/text';
import { JobGroupCode } from '@domain/constant/filterType';
import { FontStyle } from '@domain/constant/fontStyle';
import { JobTypeCode } from '@domain/constant/jobType';
import { useQuestionAnswerResult } from '@repository/interviewPractices/useInterviewPractices';
import DateFormat from '@utils/date/format';
import classNames from 'classnames/bind';
import { InterviewVideoPlayer } from '../../practice/common/video/player/interviewVideoPlayer';
import { Intention } from '../../practice/finish/result/components/intention';
import styles from './index.module.scss';

const cx = classNames.bind(styles);

interface Props extends ModalProps {
  onClose: () => void;
  questionSn: number;
}

export const HistoryDetailModal = ({ visible, onClickBg, onClose, questionSn }: Props) => {
  const { data } = useQuestionAnswerResult(questionSn);
  if (!data) return null;

  const dateObj = new Date(data.dateTime);
  const date = DateFormat.format(dateObj, 'yyyy.MM.dd');
  const time = DateFormat.format(dateObj, 'HH:mm');

  const jobTypeText = () => {
    switch (data.jobTypeCode) {
      case JobTypeCode.NEW:
        return '신입';
      case JobTypeCode.CAREER:
        return '경력';
      case JobTypeCode.INTERNSHIP:
        return '인턴';
    }
  };

  const jobGroupText = () => {
    switch (data.jobGroupCode) {
      case JobGroupCode.COMMON:
        return '직군 공통';
      case JobGroupCode.SALES:
        return '영업';
      case JobGroupCode.RESEARCH:
        return '연구 · 개발';
      case JobGroupCode.MANAGEMENT:
        return '경영기획 · 지원';
      case JobGroupCode.MARKETING:
        return '홍보 · 마케팅';
      case JobGroupCode.PRODUCTION:
        return '생산 · 유통 · 품질';
      case JobGroupCode.ENGINEER:
        return '건설 엔지니어';
      case JobGroupCode.IT:
        return 'IT 서비스';
      case JobGroupCode.DESIGN:
        return '디자인';
      case JobGroupCode.CS:
        return '서비스 · 고객지원';
      case JobGroupCode.FINANCE:
        return '금융 · 보험';
      case JobGroupCode.MEDICAL:
        return '의료 · 보건';
      default:
        return '';
    }
  };

  return (
    <Modal visible={visible} onClickBg={onClose}>
      <div className={cx('wrapper')}>
        <div className={cx('title')}>
          <Text fontStyle={FontStyle.H4_B}>연습 기록을 확인해보세요!</Text>
        </div>

        <div className={cx('divider')} />

        <div className={cx('scrollArea')}>
          <div className={cx('scrollInner')}>
            <div className={cx('content')}>
              <div className={cx('questionInfo')}>
                <div className={cx('labelArea')}>
                  <div className={cx('label')}>
                    <span>{data?.badgeTitle}</span>
                    {!!jobTypeText() && <span className={cx('item')}>{jobTypeText()}</span>}
                    {!!jobGroupText() && <span className={cx('item')}>{jobGroupText()}</span>}
                  </div>
                  <div>
                    {date} {time}
                  </div>
                </div>

                <Text fontStyle={FontStyle.B2_B}>
                  <span className={cx('emphasis')}>Q. </span>
                  {data?.questionText}
                </Text>
              </div>

              <InterviewVideoPlayer className={cx('videoArea')} source={data.answerVideoUrl ?? null} />

              <Intention data={data} />
            </div>
          </div>
        </div>

        <div className={cx('footer')}>
          <Button onClick={onClose} styles={{ width: 168, height: 48 }}>
            완료
          </Button>
        </div>
      </div>
    </Modal>
  );
};
